import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"

import { cn } from "@/lib/utils"

const Slider = React.forwardRef(({ className, 'aria-label': label, 'aria-labelledby': labelledBy,
  'aria-valuemin': _min, 'aria-valuemax': _max, 'aria-valuenow': _now, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn("relative flex w-full touch-none select-none items-center", className)}
    {...props}>
    <SliderPrimitive.Track
      className="relative h-1 w-full grow overflow-hidden rounded-full bg-[#DDE1E5]">
      <SliderPrimitive.Range className="absolute h-full bg-[#171A1D]" />
    </SliderPrimitive.Track>
    <SliderPrimitive.Thumb
      aria-label={label} aria-labelledby={labelledBy}
      data-testid={props['data-testid'] ? `${props['data-testid']}-thumb` : undefined}
      className="block h-5 w-5 rounded-full border-2 border-[#66707A] bg-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
))
Slider.displayName = SliderPrimitive.Root.displayName

export { Slider }
